import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/st-front-prediction-predik-h5/apps/predik-next/app/global-error.tsx");
